import styled from '@emotion/styled';
import { minWidth, padding } from 'styled-system';
import { Box } from 'localmed-core';
import { css } from '@emotion/core';

export default styled(Box)(
  ({ theme, selected }: any) => css`
    border-radius: ${theme.radii.lg};
    border: ${selected ? 'none' : `1px solid ${theme.colors.lightGray}`};
    padding: ${theme.space.md};
    background-color: ${selected ? theme.colors.blue : 'transparent'};
    color: ${selected ? theme.colors.white : theme.colors.blue};
    min-width: 300px;
    text-align: center;
    transition-duration: 200ms;
  `,
  minWidth,
  padding
);
